import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../../../dataManagement/uiDb/UiDb";
import {
  loadProductDetailsById,
  loadPublicProductDetailsById,
  loadProductDetailsByIds
} from "../../../../../services/thunks/ProductDetailsThunks";
import { setActiveProductId } from "../../../../../dataManagement/uiDb/ProductDetailsDb";
import { ProductDetailsModal } from "../../../../../interfaces/ProductObject";

export interface UseProductDetailsV2Result {
  productId: string | undefined;
  product: ProductDetailsModal | undefined;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean;
}

export function useProductDetailsV2(): UseProductDetailsV2Result {
  const { id: productId } = useParams<{ id: string }>();
  const dispatch: AppDispatch = useDispatch();
  const didRunRef = useRef(false);

  const isAuthenticated = useSelector(
    (state: RootState) => !!state.profile.profileData?.userId
  );

  const product = useSelector((state: RootState) =>
    productId ? state.productDetails.data[productId] : undefined
  );

  const loading = useSelector(
    (state: RootState) => state.productDetails.loading
  );

  const error = useSelector(
    (state: RootState) => state.productDetails.error
  );

  useEffect(() => {
    if (!productId || didRunRef.current) return;
    didRunRef.current = true;

    dispatch(setActiveProductId(productId));

    if (isAuthenticated) {
      dispatch(loadProductDetailsById(productId));
    } else {
      dispatch(loadProductDetailsByIds([productId]));
    }
  }, [productId, isAuthenticated, dispatch]);

  return { productId, product, loading, error, isAuthenticated };
}
